<script setup>
import { getGoogleAuthUrl } from '../../../helpers/helper';

const props = defineProps({
	label: {
		type: String,
		default: 'Continue with Google',
	},
});

function handleGoogleAuth() {
	// The SSO service performs the Google round-trip and returns here with
	// a one-time ?code=... which /auth/google/callback redeems.
	const redirectTo = `${window.location.origin}/auth/google/callback`;
	window.location.href = getGoogleAuthUrl(redirectTo);
}
</script>

<template>
	<button type="button" class="google-auth" @click="handleGoogleAuth">
		<svg class="google-auth__icon" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9082c1.7018-1.5668 2.6841-3.874 2.6841-6.615z"/>
			<path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1818l-2.9082-2.2581c-.8059.54-1.8368.8595-3.0482.8595-2.344 0-4.3282-1.5831-5.036-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z"/>
			<path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2823-1.1168-.2823-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.3477 2.8268.9573 4.0418L3.964 10.71z"/>
			<path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C15.4636.8918 13.4264 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.656 3.5795 9 3.5795z"/>
		</svg>
		<span>{{ props.label }}</span>
	</button>
</template>

<style lang="scss" scoped>
.google-auth {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	width: 100%;
	height: 44px;
	padding: 0 16px;
	background: #fff;
	border: 1px solid #7D747E;
	border-radius: 5px;
	cursor: pointer;
	font-family: 'Lato', sans-serif;
	font-size: 14px;
	font-weight: 600;
	color: #1D1B20;
	transition: background-color 0.15s ease-in-out;

	&:hover {
		background: #F5F5F5;
	}

	&:active {
		background: #ECECEC;
	}

	&__icon {
		flex-shrink: 0;
	}
}
</style>
